import { render, staticRenderFns } from "./ContainerPrice.vue?vue&type=template&id=4206d2b6&scoped=true"
import script from "./ContainerPrice.vue?vue&type=script&lang=js"
export * from "./ContainerPrice.vue?vue&type=script&lang=js"
import style0 from "./ContainerPrice.vue?vue&type=style&index=0&id=4206d2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4206d2b6",
  null
  
)

export default component.exports